import { render } from "./SeStdTaxForm1065.vue?vue&type=template&id=2c5126f2"
import script from "./SeStdTaxForm1065.vue?vue&type=script&lang=js"
export * from "./SeStdTaxForm1065.vue?vue&type=script&lang=js"

import "./SeStdTaxForm1065.vue?vue&type=style&index=0&id=2c5126f2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__